import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Truck, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../api";

const BG_IMG = "https://images.unsplash.com/photo-1647999534523-6c5d73b8bf26?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxwYWxtJTIwb2lsJTIwcGxhbnRhdGlvbnxlbnwwfHx8fDE3ODQzNjUzNjZ8MA&ixlib=rb-4.1.0&q=85";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-zinc-100">
      <div className="hidden lg:block lg:w-1/2 relative">
        <img src={BG_IMG} alt="Perkebunan kelapa sawit" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-emerald-950/60" />
        <div className="absolute bottom-0 left-0 p-12 text-white">
          <h2 className="text-3xl font-semibold tracking-tight">Manajemen Perjalanan Truk</h2>
          <p className="mt-3 text-emerald-100 max-w-md text-sm leading-relaxed">
            Kelola surat jalan, tonase muat &amp; bongkar, serta status perjalanan armada CPO, Palm Kernel dan Cangkang dalam satu sistem.
          </p>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-11 h-11 rounded-md bg-emerald-700 flex items-center justify-center">
              <Truck className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="text-lg font-semibold tracking-tight text-zinc-900">Trip Surat Jalan</h1>
              <p className="text-xs text-zinc-500">Admin Operasional</p>
            </div>
          </div>
          <h2 className="text-2xl font-semibold tracking-tight text-zinc-900 mb-1">Masuk</h2>
          <p className="text-sm text-zinc-500 mb-6">Gunakan akun admin operasional Anda.</p>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="login-email-input" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} placeholder="admin@trip.co.id" className="bg-white" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Password</Label>
              <Input id="password" data-testid="login-password-input" type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="bg-white" />
            </div>
            {error && (
              <p data-testid="login-error-message" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">{error}</p>
            )}
            <Button data-testid="login-submit-button" type="submit" disabled={loading}
              className="w-full bg-emerald-700 hover:bg-emerald-800 text-white transition-colors duration-200 btn-touch">
              {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
              Masuk
            </Button>
          </form>
          <p className="text-sm text-zinc-500 mt-6">
            Belum punya akun?{" "}
            <Link data-testid="register-link" to="/register" className="text-emerald-700 font-medium hover:underline">Daftar</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
